// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__KuT-s","content":"Layout_content__3nMgS","header":"Layout_header__1V-LV","centeredTitle":"Layout_centeredTitle__2RLAr"};